
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-custom.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-custom-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-custom.en-US.md?type=demo')
};